<template>
  <div class="default-dashboard full-height">
    <transition class="full-height">
      <keep-alive :include="$route.meta.include">
        <router-view />
      </keep-alive>
    </transition>
  
    <van-tabbar
      safe-area-inset-bottom
      v-if="isYlslh5"
    >
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <van-col
          v-for="(tab,index) in tabbarList"
          :key="tab.link"
          :span="tabbarList.length == 3 ? 8 : 12"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>
  
    <van-tabbar
      class="shadow"
      v-if="!isXlminiprogram && !isYlslh5"
    >
      <van-row
        type="flex"
        align="center"
        class="nav-tabbar"
        safe-area-inset-bottom
      >
        <!-- :span="(tabbarList.length == 4 ? 6 : ((tabbarList.length == 5 && index == 2) ? 4 : 5))" -->
        <van-col
          v-for="(tab,index) in tabbarList"
          :key="tab.link"
          :span="(tabbarList.length == 4 ? 6 : tabbarList.length > 5 ? 4 : ((tabbarList.length == 5 && index == 2) ? 4 : 5))"
          @click.native="$router.push({ path: tab.link, query: tab.query })"
        >
          <van-badge
            :content="tab.count?tab.count:''"
            max="99"
          >
            <van-image
              width="24"
              height="24"
              :src="tab.normalImg"
              v-show="!(hashAddr == tab.link || hashAddr == tab.otherLink)"
            />
            <van-image
              width="24"
              height="24"
              :src="tab.activeImg"
              v-show="hashAddr == tab.link || hashAddr == tab.otherLink"
            />
            <div>{{ $t(tab.title) }}</div>
          </van-badge>
        </van-col>
      </van-row>
    </van-tabbar>
  </div>
</template>
  
<script>
import home from 'Components/Dynamic/default/images/navbar/home.png'
import home1 from 'Components/Dynamic/default/images/navbar/home1.png'
import user from 'Components/Dynamic/default/images/navbar/user.png'
import user1 from 'Components/Dynamic/default/images/navbar/user1.png'
import approval from 'Components/Dynamic/default/images/navbar/approval.png'
import approval1 from 'Components/Dynamic/default/images/navbar/approval1.png'
import triplist from 'Components/Dynamic/default/images/navbar/triplist.png'
import message from 'Components/Dynamic/default/images/navbar/message.png'
import message1 from 'Components/Dynamic/default/images/navbar/message1.png'
import count from 'Components/Dynamic/default/images/navbar/count.png'
import count1 from 'Components/Dynamic/default/images/navbar/count1.png'
import allorders from 'Components/Dynamic/default/images/navbar/allorder.png'
import allorders1 from 'Components/Dynamic/default/images/navbar/allorder1.png'
import allorder from 'Components/Dynamic/default/images/navbar/allorder.png'
import allorder1 from 'Components/Dynamic/default/images/navbar/allorder1.png'
  
  
import { mapGetters } from 'vuex'
import { localget } from 'Utils/storage.js'
import { Image as VanImage, Badge ,Tabbar} from 'vant'
import defaultMixin from '@/business/mixins/default'
import {queryVipParameter} from 'Utils/publicApi'
  
export default {
  name: 'Dashboard',
  mixins:[defaultMixin],
  components:{
    [VanImage.name]: VanImage,
    [Badge.name]: Badge,
    [Tabbar.name]: Tabbar,
  },
  data () {
    return {
      hashAddr: '/home',
      taberr:[] //隐藏的taberr
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      badgeDotCount: 'badgeDotCount'
    }),
    tabbarList() {
      let obj = []
      if (this.isYlslh5){//这个是小程序的基本没动还是原来的，如果发生产的话需要改成下面的
        obj=[
          {
            link: '/tk/tkQuery',
            title: 'A003',//首页
            count:'',
            normalImg: home,
            activeImg: home1
          },
          {
            link: '/schedule',
            title: '行程',//行程
            count:'',
            normalImg: allorder,
            activeImg: allorder1
          },
          {
            link: '/statistical',
            title: '统计', //统计
            count: '',
            normalImg: count,
            activeImg: count1
          },
          {
            link: '/allOrder?findType=1',
            otherLink:'/allOrder',
            title: 'A104',//我的订单
            count:'',
            normalImg: allorders,
            activeImg: allorders1,
          }
        ]
        if (!(this.userInfo.empInfo.travelStats && this.userInfo.empInfo.travelStats == 1)){
          obj.splice(1,1)
        }
        return obj
      }else {
        obj=[
          {
            link: '/home',
            title: 'A003',//首页
            count:'',
            normalImg: home,
            activeImg: home1
          },
          {
            link: '/schedule',
            title: '行程',//行程
            count:'',
            normalImg: allorder,
            activeImg: allorder1
          },
          {
            link: '/userCenter/message', //message
            otherLink: '/noticeList',
            title: '消息',
            count: this.badgeDotCount ? this.badgeDotCount.message:'',
            normalImg: message,
            activeImg: message1
          },
          {
            link: '/tripList',
            title: '出差',
            count:'',
            normalImg: triplist,
            activeImg: triplist
          },
          {
            link: '/approvalList',
            title: '待办',
            count: this.badgeDotCount.topay ? this.badgeDotCount.topay:'',
            normalImg: approval,
            activeImg: approval1
          },
          {
            link: '/userCenter',
            title: 'A007',//我的
            count:'',
            normalImg: user,
            activeImg: user1,
          }
        ]
        if(localStorage.getItem('Pagenew')!=1){//旧页面状态下，不显示行程
          obj=obj.filter((item)=> item.title!='行程')
        }
        let userInfo=localStorage.getItem('userInfo')
        if (!userInfo && localStorage.getItem('Pagenew')==1){ //未登陆状态下,新页面状态下
          obj.splice(2,2)
        }
      }
      if(this.taberr.length>0){ //根据后台配置隐藏消息，待办，我的
        obj=obj.filter((item)=> !this.taberr.includes(item.title))
      }

      if(this.userInfo.vipCorp){//登陆状态下单点模式,不显示出差
        if(this.userInfo.vipCorp.bookStyle==1){
          obj=obj.filter((item)=> item.title!='出差')
          return obj
        }
      }else{
        let userInfo = localget('userInfo')
        if(userInfo){
          this.$store.commit('SET_USERINFO',userInfo)
          //如果是单订模式 删除申请单的入口
          if(userInfo.vipCorp&&userInfo.vipCorp.bookStyle==1){
            obj=obj.filter((item)=> item.title!='出差')
            return obj
          }
        }
      }
      return obj
    }
  },
  async   created () {
    this.hashAddr = this.$route.path
    this.topay = sessionStorage.getItem('AgentLeng')
    let message=  await  queryVipParameter('11605008') //消息
    let to_do=await  queryVipParameter('11605009') //待办
    let my=await  queryVipParameter('11605010') //我的
    this.taberr=[]
    message.value1==1 ? this.taberr.push('消息') : '' 
    to_do.value1==1 ? this.taberr.push('待办') : '' 
    my.value1==1 ? this.taberr.push('A007') : ''
  },
  watch: {
    '$route.path': function (val) {
      if(val === '/allorder'){//默认进入订单列表中的 未出行
        this.$store.commit('SET_ORDERLISTPARAMS', { findType: '3' })
      }
      this.hashAddr = val
    }
  }
}
</script>
  
  <style lang="less" scoped>
  @deep: ~">>>";
  
  .default-dashboard {
    .nav-tabbar {
      background-color: @color-background-white;
      // position: fixed;
      // left: 0px;
      // bottom: 0px;
      // right: 0px;
      width: 100%;
      height: 50px;
      // border-radius: @border-radius-sm;
      overflow: hidden;
      text-align: center;
      padding: 4px 0;
      line-height: 1;
      display: flex;
    justify-content: space-around;
  
      .normal {
        height: 26px;
      }
  
      .active {
        height: 26px;
      }
  
      @{deep}.van-badge--fixed {
        top: 6px;
      }
    }
  
  }
  </style>
  